<div class="popup-container">

    <!-- Header -->
    <div class="popup-header">
        <mat-icon class="header-icon">local_offer</mat-icon>
        <span>Apply Promo Code</span>
        <button class="close-btn" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>

    <!-- Step: Input -->
    <div class="popup-body" *ngIf="step === 'input'">
        <p class="hint">Enter your promo code or token to receive a discount on this order.</p>

        <div class="token-input-wrap">
            <input
                class="token-input"
                type="text"
                [(ngModel)]="tokenInput"
                (keydown)="onTokenKeydown($event)"
                placeholder="Enter promo code (e.g. ABC12345)"
                [disabled]="validating"
                autocomplete="off"
                autofocus>
            <button class="validate-btn" (click)="validate()" [disabled]="validating || !tokenInput.trim()">
                <mat-icon>search</mat-icon>
                {{ validating ? 'Checking…' : 'Check' }}
            </button>
        </div>

        <div class="error-msg" *ngIf="error">
            <mat-icon>error_outline</mat-icon>
            {{ error }}
        </div>
    </div>

    <!-- Step: Confirm -->
    <div class="popup-body" *ngIf="step === 'confirm' && validResult">
        <div class="promo-preview">
            <div class="promo-badge">
                <mat-icon>check_circle</mat-icon>
                <span>Valid Promo!</span>
            </div>
            <h3 class="promo-title">{{ validResult.promoName }}</h3>
            <div class="discount-display">{{ discountDisplay }}</div>
            <div class="customer-name" *ngIf="validResult.customerName">
                <mat-icon>person</mat-icon>
                {{ validResult.customerName }}
            </div>
            <div class="savings-line">
                You save: <strong>${{ (calculatedDiscount / 100).toFixed(2) }}</strong>
            </div>
        </div>

        <div class="confirm-actions">
            <button class="back-btn" (click)="back()">
                <mat-icon>arrow_back</mat-icon> Back
            </button>
            <button class="apply-btn" (click)="applyPromo()" [disabled]="redeeming">
                <mat-icon>{{ redeeming ? 'hourglass_empty' : 'check' }}</mat-icon>
                {{ redeeming ? 'Applying…' : 'Apply Discount' }}
            </button>
        </div>
    </div>

    <!-- Step: Success -->
    <div class="popup-body success-body" *ngIf="step === 'success'">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h3>Promo Applied!</h3>
        <p>Discount has been applied to the order.</p>
    </div>

</div>
